import React from "react";

export default () => (
  <footer>
    <p>
      2018年10月1日 制定
      <br />
      2019年7月26日 改定
      <br />
      合同会社分散型ソーシャルネットワーク機構
      <br />
      東京都千代田区神田佐久間町3丁目38号 第5東ビル5階
    </p>
  </footer>
);
